import { RouteObject } from 'react-router-dom';
import AuthGuard from '@/components/feature/AuthGuard';
import MainLayout from '@/components/feature/MainLayout';
import HomePage from '@/pages/home/page';
import MusterilerPage from '@/pages/musteriler/page';
import ServisKayitlariPage from '@/pages/servis-kayitlari/page';
import BakimTakipPage from '@/pages/bakim-takip/page';
import ServisPlanlamaPage from '@/pages/servis-planlama/page';
import MesajGonderPage from '@/pages/mesaj-gonder/page';
import RaporlarPage from '@/pages/raporlar/page';
import PersonelPage from '@/pages/personel/page';
import StokPage from '@/pages/stok/page';
import FirmaAyarlarPage from '@/pages/firma-ayarlari/page';
import IslemLoglariPage from '@/pages/islem-logla/page';
import LoginPage from '@/pages/giris/page';

const routes: RouteObject[] = [
  {
    path: '/giris',
    element: <LoginPage />,
  },
  {
    element: <AuthGuard />,
    children: [
      {
        path: '/',
        element: <MainLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'musteriler', element: <MusterilerPage /> },
          { path: 'servis-kayitlari', element: <ServisKayitlariPage /> },
          { path: 'servis-planlama', element: <ServisPlanlamaPage /> },
          { path: 'bakim-takip', element: <BakimTakipPage /> },
          { path: 'mesaj-gonder', element: <MesajGonderPage /> },
          { path: 'raporlar', element: <RaporlarPage /> },
          { path: 'personel', element: <PersonelPage /> },
          { path: 'stok', element: <StokPage /> },
          { path: 'firma-ayarlari', element: <FirmaAyarlarPage /> },
          { path: 'islem-logla', element: <IslemLoglariPage /> },
        ],
      },
    ],
  },
];

export default routes;